export const POST = "post";
export const DELETE = "delete";
export const PUT = "put";
export const GET = "get";
